import { $, owlCarousel } from "./imports";

const alliancesHomeCarousel = () => {

    let $alliancesHome = $('.alliances-home__list');
    let timeoutAlliancesHome = false;

    function initAlliancesHomeCarousel() {
        $alliancesHome.addClass('owl-carousel').owlCarousel({
            nav: false,
            dots: true,
            margin: 20,
            navText: [
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M15.514,6l1.627,1.627-5.285,5.3,5.285,5.3-1.627,1.627L8.59,12.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M10.217,6,8.59,7.627l5.285,5.3L8.59,18.22l1.627,1.627,6.923-6.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>'
            ],
            rewind: true,
            items: 1,
            center: true,
            autoplay: true,
            autoplayTimeout: 8000,
            autoplayHoverPause: true,
        });
    }

    function destroyAlliancesHomeCarousel() {
        $alliancesHome.trigger("destroy.owl.carousel").removeClass("owl-carousel");
    }

    function showAlliancesHomeCarousel() {
        if ($alliancesHome.data("owlCarousel") !== "undefined") {
            if (window.matchMedia('(max-width: 992px)').matches) {
                initAlliancesHomeCarousel();
            } else {
                destroyAlliancesHomeCarousel();
            }
        }
    }

    if ($alliancesHome.length > 0) {
        /*==================== WINDOW RESIZE ====================*/
        window.addEventListener('resize', function () {
            this.clearTimeout(timeoutAlliancesHome);
            timeoutAlliancesHome = this.setTimeout(showAlliancesHomeCarousel(), 250);
        });

        showAlliancesHomeCarousel();

    }
};

export default alliancesHomeCarousel;